<template>
  <section class="section__2">
    <!-- one -->
    <a href="#" class="container__one">
      <h2>
        Understanding <br />
        the Brain
      </h2>
      <hr />
      <p class="figure__caption">FIG. 1</p>
      <div class="image__wrapper">
        <img
          class="image-1"
          src="https://d33wubrfki0l68.cloudfront.net/3e4fe4d1220d9bcc020f6963b24d16c59e0635ff/48960/images/pages/red-desktop-thumbnail.png"
          alt="understanding the brain"
        />
      </div>
      <div class="link__container">
        <h3 class="link__item">SCIENCE</h3>
        <img
          class="right__arrow"
          src="../../assets/right-arrow.png"
          alt="icon"
        />
      </div>
    </a>
    <!-- two -->
    <a href="#" class="container__two">
      <h2>
        Interfacing <br />
        with the Brain
      </h2>
      <hr />
      <p class="figure__caption">FIG. 2</p>
      <div class="image__wrapper">
        <img
          class="image-2"
          src="https://d33wubrfki0l68.cloudfront.net/195f1075dc8db7abbc3df451c37a859b62628e07/ab543/images/pages/blue-desktop-thumbnail.png"
          alt="Interfacing with the Brain"
        />
      </div>
      <div class="link__container">
        <h3 class="link__item">APPROACH</h3>
        <img
          class="right__arrow"
          src="../../assets/right-arrow.png"
          alt="icon"
        />
      </div>
    </a>
    <!-- three -->
    <a href="#" class="container__three">
      <h2>
        Engineering <br />
        with the Brain
      </h2>
      <hr />
      <p class="figure__caption">FIG. 3</p>
      <div class="image__wrapper">
        <img
          class="image-3"
          src="https://d33wubrfki0l68.cloudfront.net/5c5bbe030cd931a7cac4c3f24c89635e3abcbd31/25ba5/images/pages/green-desktop-thumbnail.png"
          alt="engineering with the brain"
        />
      </div>
      <div class="link__container">
        <h3 class="link__item">APPLICATIONS</h3>
        <img
          class="right__arrow"
          src="../../assets/right-arrow.png"
          alt="icon"
        />
      </div>
    </a>
  </section>
</template>

<script>
export default {
  name: "Section_2",
};
</script>

<style scoped>
@media only screen and (min-width: 601px) {
  a {
    text-decoration: none;
    color: white;
    font-family: "Barlow", sans-serif;
    font-size: 20px;
    font-weight: bold;
  }
  h3 {
    margin: 0;
  }
  h2 {
    margin-top: 0;
    margin-bottom: 1.2rem;
    font-family: "Times New Roman", Times, serif;
    font-weight: lighter;
    font-size: 45px;
    line-height: 43pt;
  }
  .section__2 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .image__wrapper {
    text-align: center;
  }
  .container__one {
    background-color: #c9a3a4;
    color: white;
    padding: 3.5rem;
  }
  .container__two {
    background-color: #add1ef;
    color: white;
    padding: 3.5rem;
  }
  .container__three {
    background-color: #acb5ac;
    color: white;
    padding: 3.5rem;
  }
  .image-1 {
    width: 250px;
    height: 427px;
  }
  .image-2 {
    margin-top: 2rem;
    margin-bottom: 2.4rem;
    width: 400px;
    height: 360px;
  }
  .image-3 {
    margin-top: 1rem;
    width: 400px;
    height: 419px;
  }
  .figure__caption {
    text-align: end;
    margin: 0;
    font-size: medium;
    font-weight: bold;
    font-family: "Barlow", sans-serif;
  }
  hr {
    border: 1px solid white;
  }
  .right__arrow {
    width: 15px;
    height: 20px;
    filter: invert(100);
  }
  .link__container {
    display: flex;
    align-items: center;
  }
  .link__item {
    margin-right: 0.5rem;
    font-family: "Barlow", sans-serif;
    font-size: 20px;
  }
}
/* Mobile responsive code */
@media only screen and (max-width: 600px) {
  a {
    text-decoration: none;
    color: white;
    font-family: "Barlow", sans-serif;
    font-size: 20px;
    font-weight: bold;
  }
  h3 {
    margin: 0;
  }
  h2 {
    margin-top: 0;
    margin-bottom: 1.2rem;
    font-family: "Times New Roman", Times, serif;
    font-weight: lighter;
    font-size: 30px;
    line-height: 25pt;
  }
  .section__2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }
  .image__wrapper {
    text-align: center;
  }
  .container__one {
    background-color: #c9a3a4;
    background-image: url("https://neuralink.com/images/pages/red-mobile-thumbnail.png");
    background-position: right;
    background-repeat: no-repeat;
    background-size: 50%;
    color: white;
    padding-top: 1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 0;
    /* height: 18rem; */
  }
  .container__two {
    background-color: #add1ef;
    background-image: url("https://d33wubrfki0l68.cloudfront.net/195f1075dc8db7abbc3df451c37a859b62628e07/ab543/images/pages/blue-desktop-thumbnail.png");
    background-position: right;
    background-repeat: no-repeat;
    background-size: 70%;
    background-clip: border-box;
    color: white;
    padding-top: 1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .container__three {
    background-color: #acb5ac;
    background-image: url("https://d33wubrfki0l68.cloudfront.net/5c5bbe030cd931a7cac4c3f24c89635e3abcbd31/25ba5/images/pages/green-desktop-thumbnail.png");
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
    color: white;
    padding-top: 1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 0;
  }
  .image-1 {
    display: none;
    width: 250px;
    height: 427px;
  }
  .image-2 {
    display: none;
    margin-top: 2rem;
    margin-bottom: 2.4rem;
    width: 400px;
    height: 360px;
  }
  .image-3 {
    display: none;
    margin-top: 1rem;
    width: 400px;
    height: 419px;
  }
  .figure__caption {
    text-align: start;
    margin: 0;
    font-size: medium;
    font-weight: bold;
    font-family: "Barlow", sans-serif;
  }
  hr {
    border: 1px solid white;
  }
  .right__arrow {
    width: 15px;
    height: 20px;
    filter: invert(100);
  }
  .link__container {
    display: flex;
    align-items: center;
    margin-top: 3rem;
  }
  .link__item {
    margin-right: 0.5rem;
    font-family: "Barlow", sans-serif;
    font-size: 20px;
  }
}
</style>
